import {
  Col,
  Flex,
  Form,
  Row,
  Tooltip,
  Button,
  ConfigProvider,
  Collapse
} from "antd";
import DynamicFormCase from "../DynamicFieldRenderer/DynamicFieldRenderer";
import { FaFilter } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { useActionHandler } from "../ActionHandlerContext";

const TableFilters = (
  { config }: any,


) => {
  const [form] = Form.useForm();
  const [isFiltersVisible, setIsFiltersVisible] = useState<boolean>(false);
  const [filterButtonVisibility, setFilterButtonVisibility] = useState<boolean>(false);
  const { reportActionHandler } = useActionHandler();
  const onFinish = (values: any) => {
  };

  useEffect(() => {
    if (config?.fields) {
      const shouldShowFilterButton = config.fields.some((section: { content: any[] }) =>
        section.content.some((field) => field.visibilityType === "Header,Filter" || field.visibilityType === "Filter")
      );
      setFilterButtonVisibility(shouldShowFilterButton);
    }
  }, [config]);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ width: "100%" }}
      //by kausher
      onValuesChange={(changedValues, allValues) => {
        const changedFieldNames = Object.keys(changedValues);

        const allFields = config?.fields?.flatMap(
          (section: any) => section.content,
        );

        const isQuickFilterChanged = changedFieldNames.some((changedName) =>
          allFields?.some((field: any) => {
            const matchesField =
              field?.dataIndex === changedName ||
              field?.name === changedName ||
              field?.key === changedName;

            if (!matchesField) return false;

            return field?.visibilityType
              ?.split(",")
              ?.map((v: string) => v.trim())
              ?.includes("QuickFilter");
          }),
        );

        if (isQuickFilterChanged) {
          console.log("Quick filter detected:", changedFieldNames);
          setTimeout(() => {
            reportActionHandler?.QuickFilterChange?.(form);
          }, 0);
        }
      }}
      //by kausher
    >
      <div>
        {config?.fields?.map((section: any) => (
          <div key={section.key}>
            {Array.isArray(section.content) && section.content.length > 0 ? (
              <>
                {/* Row for Header,QuickFilter + Buttons */}
                <Row
                  gutter={12}
                  justify={section.justify}
                  align={section.alignItems}
                >
                  <Col lg={22} md={12} sm={24} xs={24}>
                    <Row gutter={16}>
                      {section.content.map((field: any, index: number) => {
                        // Check if the field is valid and its visibilityType is either "QuickFilter" or "Header,QuickFilter"
                        if (
                          !field ||
                          Object.keys(field).length === 0 ||
                          !["QuickFilter", "Header,QuickFilter"].includes(
                            field.visibilityType,
                          )
                        ) {
                          return null;
                        }

                        const colSpan =
                          field.type?.toLowerCase() === "addrowtable" ? 24 : 8;

                        return (
                          <Col
                            lg={colSpan}
                            md={12}
                            sm={24}
                            xs={24}
                            key={`quickfilter-${crypto.randomUUID()}`}
                          >
                            <ConfigProvider
                              theme={{
                                components: {
                                  Collapse: {
                                    headerPadding: undefined,
                                  },
                                },
                              }}
                            >
                              <DynamicFormCase
                                field={field}
                                form={form}
                                keyIdentity=""
                                actionType=""
                                fields={section.content}
                                dataSource={undefined}
                                colsize={24}
                              />
                            </ConfigProvider>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>

                  {/* Button Column */}
                  <Col lg={2} md={12} sm={24} xs={24}>
                    <div className="d-flex justify-content-end filt-btn">
                      <Flex className="gap-2">
                        {filterButtonVisibility && (
                          <Tooltip
                            title={
                              isFiltersVisible
                                ? "Hide advanced filter options"
                                : "Show advanced filter options"
                            }
                          >
                            <Button
                              className="filterBtn"
                              shape="circle"
                              color="default"
                              variant="text"
                              icon={<FaFilter />}
                              onClick={() =>
                                setIsFiltersVisible(!isFiltersVisible)
                              }
                            />
                          </Tooltip>
                        )}
                        {/* <Button
                          className="btn-submit"
                          onClick={() =>
                            reportActionHandler["ApplyBtnClick"](form)
                          }
                        >
                          Apply
                        </Button>

                        <Button
                          className="btn-reset"
                          onClick={() =>
                            reportActionHandler["ResetBtnfilter"](form)
                          }
                        >
                          Reset
                        </Button> */}
                      </Flex>
                    </div>
                  </Col>
                </Row>

                {/* Row for Header,Filter */}
                <Row
                  gutter={12}
                  style={section.boxStyle}
                  justify={section.justify}
                  align={section.alignItems}
                >
                  {section.content.map((field: any, index: number) => {
                    // Check if the field is valid and its visibilityType is either "Filter" or "Header,Filter"
                    if (
                      !field ||
                      Object.keys(field).length === 0 ||
                      !["Filter", "Header,Filter"].includes(
                        field.visibilityType,
                      )
                    ) {
                      return null;
                    }

                    const colSpan =
                      field.type?.toLowerCase() === "addrowtable" ? 24 : 6;

                    return (
                      <Col
                        lg={colSpan}
                        md={12}
                        sm={24}
                        xs={24}
                        key={`filter-${crypto.randomUUID()}`}
                      >
                        <ConfigProvider
                          theme={{
                            components: {
                              Collapse: {
                                headerPadding: undefined,
                              },
                            },
                          }}
                        >
                          <Collapse
                            activeKey={isFiltersVisible ? "1" : undefined}
                            bordered={false}
                            expandIcon={() => null}
                            className="advance_filter"
                            ghost
                            items={[
                              {
                                key: 1,
                                collapsible: "disabled",
                                showArrow: false,
                                forceRender: true,
                                children: (
                                  <DynamicFormCase
                                    field={field}
                                    form={form}
                                    keyIdentity=""
                                    actionType=""
                                    fields={section.content}
                                    dataSource={undefined}
                                    colsize={24}
                                    // Missing required props:
                                    hideShowField={() => {}}
                                    runInterfaceFieldActionChange={() => {}}
                                    dataEditableSource={[]}
                                  />
                                ),
                              },
                            ]}
                          />
                        </ConfigProvider>
                      </Col>
                    );
                  })}
                </Row>
                <div
                  className={`w-100 d-flex justify-content-end ${isFiltersVisible ? "mb-2" : ""}`}
                >
                  <Flex className="gap-2">
                    {isFiltersVisible && (
                      <>
                        <Button
                          className="btn-submit"
                          onClick={() =>
                            reportActionHandler["ApplyBtnClick"](form)
                          }
                        >
                          Apply
                        </Button>

                        <Button
                          className="btn-reset"
                          onClick={() =>
                            reportActionHandler["ResetBtnfilter"](form)
                          }
                        >
                          Reset
                        </Button>
                      </>
                    )}
                  </Flex>
                </div>
              </>
            ) : (
              <p>No fields available</p>
            )}
          </div>
        ))}
      </div>
    </Form>
  );
};

export default TableFilters;
